module.exports = __webpack_public_path__ + "img/online-learning-4@2x.1a86b16.jpg";